import DraggableModal from 'components/organisms/draggableModal';
import { useTranslation } from 'react-i18next';
import { DateFormats } from 'infrastructure/enums';
import { convertDateToTimeZone, DateFormatter } from 'infrastructure/functions';

import ReadingItem from './reading-item';
import Status from './status';
import s from './styles.module.scss';

import type { IPatientThresholds } from 'infrastructure/interfaces';
import type { ILinkedCallReadings } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

interface LinkedReadingsModalProps {
  open: boolean;
  toggle: () => void;
  linkedCallReadings: ILinkedCallReadings[];
  thresholds: IPatientThresholds;
  patientTimezone: string;
}

const LinkedReadingsModal: FC<LinkedReadingsModalProps> = ({
  open,
  toggle,
  linkedCallReadings,
  thresholds,
  patientTimezone,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <DraggableModal
      isOpen={open}
      toggle={toggle}
      title={t('linkedCallReadings.linkedReadings', {
        count: linkedCallReadings.length,
      })}
      footer={false}
    >
      <div className={s['item-wrapper']}>
        {linkedCallReadings.map((reading, idx) => {
          const date = DateFormatter({
            date: new Date(parseInt(reading.createdAt)),
            format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
          });
          const patientTime = convertDateToTimeZone(
            new Date(parseInt(reading.createdAt)),
            patientTimezone,
          );
          const patientDate = DateFormatter({
            date: patientTime,
            format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
          });
          return (
            <div key={reading.id + idx} className={s['item-body']}>
              <div className={s['item-header']}>
                <Status
                  globalStatus={reading.globalStatus}
                  thresholdName={reading.thresholdName}
                  isRecovered={reading.isRecovered}
                />
                <div className={s['item-header-dates']}>
                  <p>
                    <span className={s['item-index']}>#{idx + 1} </span>
                    <span className={s['item-date']}>{date}</span>
                  </p>
                  <p className={s['item-local-date']}>
                    {t('labels.localTime')}:{' '}
                    <span className={s['item-date']}>{patientDate}</span>
                  </p>
                </div>
              </div>
              <ReadingItem
                globalStatus={reading.globalStatus}
                readingType={reading.readingType}
                values={reading.value}
                statuses={reading.statuses}
                thresholdName={reading.thresholdName}
                thresholds={thresholds}
              />
            </div>
          );
        })}
      </div>
    </DraggableModal>
  );
};
export default LinkedReadingsModal;
